import "./Workcardstyle.css";
import React from 'react';
import my from "../assets/mine.jpg"
import { NavLink } from "react-router-dom";
import Workcard from "./Workcard";
import Workcarddata from"./Workcarddata";
const Work = () => {
  return (
    <div className="work-container">
      <h1 className="role">Founders</h1>
      <div className="description">

        {Workcarddata.map((val,ind)=>{
            return(
                <Workcard 
                key={ind}
                imgsrc={val.imgsrc}
                title={val.title}
                text={val.text}
                view={val.view}
                social={val.social}
                />
            )
        })}
      </div>
    </div>

      
    
  )
}

export default Work;
